import * as core from '../../../../../../../core'
import * as stakeholderEngagementNeeded from '../stakeholder-engagement-needed'

export const RESOURCE = {
  payload: {
    description: 'High-Touch / Individual',
    enumId: core.dms.models.Enum.Id.from({
      partialId: stakeholderEngagementNeeded.RESOURCE.payload.partialId,
    }),
    id: 'High-Touch / Individual',
    name: 'High-Touch / Individual',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
